import MainFrame from "@/Layout/Layout";
import PortfolioIntroduction from "@pages/portfolio/components/PortfolioIntroduction";
import ProductsPreviewer from "@pages/portfolio/components/ProductsPreviewer";
import slide2 from "@images/slider/slide-2.jpg";
import { SimplifiedContactForm } from "@pages/contact/ContactUsView";
import { useEffect } from "react";

const PortfolioView = () => {
  useEffect(() => {
    if (window.location.hash.startsWith("#portfolio-previewer")) {
      setTimeout(() => {
        const section = document.getElementById("portfolio-previewer");
        if (section) {
          const offset = window.innerHeight / 2 - section.clientHeight / 2;
          window.scrollTo({
            top: section.offsetTop - offset,
            behavior: "smooth",
          });
        }
      }, 500);
    }
  }, []);

  return (
    <MainFrame>
      <div
        className="h-[60vh] w-full"
        style={{
          backgroundImage: `url(${slide2})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <PortfolioIntroduction />
      <ProductsPreviewer />
      <SimplifiedContactForm />
    </MainFrame>
  );
};

export default PortfolioView;
